import React from "react";
import styles from "./footer.module.css";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <p>© 2024 SwiftBuy. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
